/**
 * Z-Index Layer Scale
 * 
 * App-wide z-index constants to prevent overlay conflicts.
 * All overlays should use these values, not arbitrary numbers.
 * 
 * Rule: Nothing should ever use a z-index higher than Z_SYSTEM
 * unless it's a critical system overlay (error boundaries, etc.)
 */

export const Z_LAYERS = {
  // Base layers (0-99)
  CANVAS: 0,
  BACKGROUND: 1,
  
  // Content layers (100-999)
  CONTENT: 100,
  CARDS: 200,
  
  // Overlay layers (1000-9999)
  INSTRUCTIONS: 1000,
  ZOOM_INDICATOR: 1000,
  
  // Control layers (10000-99999)
  FAB_CONTROLS: 50000,
  
  // Profile card - needs to be above canvas and controls
  PROFILE_CARD: 2147483640,  // Very high to be above Emergent watermark
  PROFILE_BACKDROP: 2147483639,
  
  // Modal layers (100000+)
  MODAL: 100000,
  TOAST: 2147483647,  // Highest for toasts
  
  // System layers (highest priority)
  DEBUG_PANEL: 999999,
  SYSTEM: 1000000,
};

/**
 * Get z-index style object
 * @param {string} layer - Layer name from Z_LAYERS
 * @returns {object} Style object with zIndex
 */
export function zLayer(layer) {
  const index = Z_LAYERS[layer];
  if (index === undefined) {
    console.warn(`[Z-Index] Unknown layer: ${layer}`);
    return { zIndex: 0 };
  }
  return { zIndex: index };
}

export default Z_LAYERS;
